import { useState, type ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/cn';

/** Collapsible section used by Configuración. */
export function Accordion({
  icon,
  title,
  subtitle,
  badge,
  defaultOpen = false,
  children,
}: {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  badge?: ReactNode;
  defaultOpen?: boolean;
  children?: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="surface overflow-hidden">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center gap-3 px-5 py-4 text-left transition-colors hover:bg-subtle"
      >
        {icon && <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-primary-soft text-primary-text">{icon}</span>}
        <span className="min-w-0 flex-1">
          <span className="flex items-center gap-2">
            <span className="text-sm font-semibold text-ink-strong">{title}</span>
            {badge != null && (
              <span className="rounded-md bg-hover px-1.5 py-0.5 text-2xs text-ink-muted">{badge}</span>
            )}
          </span>
          {subtitle && <span className="mt-0.5 block text-xs text-ink-muted">{subtitle}</span>}
        </span>
        <ChevronDown className={cn('h-4 w-4 shrink-0 text-ink-faint transition-transform', open && 'rotate-180')} />
      </button>
      {open && children && <div className="border-t border-hairline px-5 py-5">{children}</div>}
    </section>
  );
}
